import React,{Component} from 'react';
import {formatPrice,formatQuantity} from '../helpers/helpers'

class QHardwareView extends Component{
   

    render() {  
            
        return (
                <tr>
                    <td>{this.props.product.productName}</td>
                    <td></td>
                    <td></td>
                    <td>{formatQuantity(this.props.product.productNumber)}</td>
                    <td>{this.props.product.productUnit}</td>
                    <td>{formatPrice(this.props.product.productPrice)}</td>
                    <td>{this.props.product.productUnit}</td>
                    <td>{this.props.product.productDiscount}%</td>
                    <td>{formatPrice(this.props.product.productTotal)}</td>
                </tr>
                    
 
        );
    }
}

export default  QHardwareView;


// WEBPACK FOOTER //
// ./src/components/QHardwareView.js